module.exports = __webpack_public_path__ + "img/graph3.3ef03355.png";